module.exports = __webpack_public_path__ + "static/media/line.f5f2b11a.jpg";